const WorkOrderStatusEnum = {
  Open: 1,
  InProgress: 2,
  Completed: 3,
  Canceled: 4
};

const WorkOrderStatusList = [
  { id: WorkOrderStatusEnum.Open, label: "Aberta", variant: "info" },
  { id: WorkOrderStatusEnum.InProgress, label: "Em execução", variant: "warning" },
  { id: WorkOrderStatusEnum.Completed, label: "Concluída", variant: "success" },
  { id: WorkOrderStatusEnum.Canceled, label: "Cancelada", variant: "secondary" }
];

const Transitions = {
  [WorkOrderStatusEnum.Open]: [
    WorkOrderStatusEnum.InProgress,
    WorkOrderStatusEnum.Canceled
  ],
  [WorkOrderStatusEnum.InProgress]: [
    WorkOrderStatusEnum.Completed,
    WorkOrderStatusEnum.Canceled
  ],
  [WorkOrderStatusEnum.Completed]: [],
  [WorkOrderStatusEnum.Canceled]: []
};

const WorkOrderStatus = {
  Enum: WorkOrderStatusEnum,
  List: WorkOrderStatusList,

  Label(status) {
    let item = WorkOrderStatusList.find((x) => x.id === status);
    return item ? item.label : "";
  },

  Variant(status) {
    let item = WorkOrderStatusList.find((x) => x.id === status);
    return item ? item.variant : "secondary";
  },

  IsFinal(status) {
    return (
      status === WorkOrderStatusEnum.Completed ||
      status === WorkOrderStatusEnum.Canceled
    );
  },

  AllowedTransitions(status) {
    let allowed = Transitions[status] || [];
    return WorkOrderStatusList.filter((x) => allowed.indexOf(x.id) >= 0);
  }
};

export default WorkOrderStatus;
